<template>
    <auth-layout-content :title="$t(signupTitleCode)" :message="message" :hasRightSide="!finalizeAccountToken">
        <template #left-side>
            <sign-up-form
                ref="signUpForm"
                :finalizeAccountToken="finalizeAccountToken"
                @success="showSuccessMessage"
            ></sign-up-form>
        </template>
    </auth-layout-content>
</template>

<script>
    import AuthLayoutContent from 'components/layouts/layout-content/AuthLayoutContent'
    import SignUpForm from 'components/forms/auth/SignUpForm'
    import RoutesEnum from 'enums/routes.enum'
    import AuthService from '../../services/AuthService'
    import AuthAPI from 'api/AuthAPI'

    export default {
        components: { AuthLayoutContent, SignUpForm },

        data: () => ({
            RoutesEnum,
            message: null,
            finalizeAccountToken: null,
            signupTitleCode: 'pages.auth.signup.title',
        }),

        methods: {
            showSuccessMessage() {
                this.message = {
                    text: this.$t(`pages.auth.signup.messages.${this.finalizeAccountToken ? 'invite' : 'register'}_success`),
                    type: 'success',
                }
            },

            getClientData() {
                AuthAPI.getClientData({ finalizeAccountToken: this.finalizeAccountToken })
                    .then((response) => {
                        if (response.language) {
                            this.$i18n.locale = response.language
                        }
                        this.$refs.signUpForm.data.email = response.email
                        this.$refs.signUpForm.data.firstName = response.firstName
                        this.$refs.signUpForm.data.lastName = response.lastName
                    })
                    .catch((error) => {
                        if (error.statusCode === 400) {
                            this.$toast.error(this.$t(`forms.auth.signup.errors.token_invalid`))
                            this.$router.push({
                                name: RoutesEnum.AUTH.LOGIN,
                            })
                        }
                    })
            },
        },

        mounted() {
            if (AuthService.isSubdomainActive()) {
                AuthService.reloadSubdomainCompany()
            }
            const invitationTokenQueryParam = this.$route.query['tkn']
            if (invitationTokenQueryParam) {
                this.finalizeAccountToken = invitationTokenQueryParam
                this.signupTitleCode = 'pages.auth.signup.finalize_profile'
                this.getClientData()
            }
        },
    }
</script>
